import { useEffect, useState } from "react";
import { evaluateFlag } from "@/lib/featureFlags";
import { FLOW_UI_FLAG_KEY, applyFlowUi, isFlowUiActive } from "@/lib/flowUi";

/**
 * Resolves the `flow_ui_enabled` flag and paints the Flow UI attribute on
 * <html>. Fails closed: any error leaves the existing visual system intact.
 */
export function useFlowUi(): { enabled: boolean; resolved: boolean } {
  const [enabled, setEnabled] = useState(() => isFlowUiActive());
  const [resolved, setResolved] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      let on = false;
      try {
        on = (await evaluateFlag(FLOW_UI_FLAG_KEY)).on;
      } catch {
        on = false;
      }
      if (cancelled) return;
      applyFlowUi(on);
      setEnabled(on);
      setResolved(true);
    })();
    return () => { cancelled = true; };
  }, []);

  return { enabled, resolved };
}
